// import React, { useEffect, useRef, useState, useMemo } from "react";
// import { Container, Row, Modal, Form } from "reactstrap";
// import { useParams } from "react-router-dom";
// import { PDFViewer } from "@react-pdf/renderer";
// import axios from "axios";
// import Loader from "pages/Separate/Loader";
// import configure from "configure";
// import Swal from "sweetalert2";
// import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
// import { MyProposalDocument } from "./ProposalPdf";
// import { ProposalPDFDoc } from "./ProposalPdfBlank";

// const GenerateLinkProposal = () => {
//   const { id: junk_link } = useParams();
//   const [isLoading, setLoading] = useState(false);
//   const [expire, setExpire] = useState(null); // null = loading
//   const [proposalData, setProposalData] = useState(null);
//   const [rfpData, setRfpData] = useState(null);
//   const [rejectModal, setRejectModal] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [responded, setResponded] = useState(false);
//   const [fixedRightSec, setFixedRightSec] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setFixedRightSec(window.scrollY > 48);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => { fetchProposal(); }, []);

//   const fetchProposal = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `${configure.nodeApi}/get_proposal_by_junk_link/${junk_link}`,
//         { headers: { Accept: "application/json" } }
//       );
//       if (res.data.success && res.data.data) {
//         const d = res.data.data;
//         setProposalData(d);
//         setExpire(false);

//         // Check if already responded
//         if (d.proposal_response?.action) setResponded(true);

//         // Fetch RFP if linked to lead
//         if (d.related === "lead" && d.source_name && d.source_name !== "null") {
//           try {
//             const rfpRes = await axios.get(
//               `${configure.nodeApi}/get_rfp_by_lead/${d.source_name}`,
//               { headers: { Accept: "application/json" } }
//             );
//             if (rfpRes.data.success && rfpRes.data.data) setRfpData(rfpRes.data.data);
//           } catch {}
//         }
//       } else {
//         setExpire(true);
//       }
//     } catch {
//       setExpire(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAccept = async () => {
//     const { isConfirmed } = await Swal.fire({
//       title: "Accept Proposal?",
//       text: "By accepting, you agree to proceed with this proposal.",
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Accept",
//       confirmButtonColor: "#28a745",
//     });
//     if (!isConfirmed) return;

//     setLoading(true);
//     try {
//       await axios.post(`${configure.nodeApi}/proposal_response`, {
//         junk_link, action: "accepted", reason: null
//       });
//       setResponded(true);
//       Swal.fire({ icon: "success", text: "Proposal Accepted! We'll be in touch soon." });
//     } catch {
//       Swal.fire({ icon: "error", text: "Something went wrong." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Parse terms for display ──
  
//   const handleReject = async () => {
//   if (!rejectReason.trim()) return;
//   setLoading(true);
//   try {
//     await axios.post(`${configure.nodeApi}/proposal_response`, {
//       junk_link, action: "rejected", reason: rejectReason
//     });
//     setResponded(true);
//     setRejectModal(false);
//     Swal.fire({ icon: "info", text: "Proposal declined. Thank you for your feedback." });
//   } catch {
//     Swal.fire({ icon: "error", text: "Something went wrong." });
//   } finally {
//     setLoading(false);
//   }
// };

// // Add this helper after handleReject
// const handleDownloadPdf = async () => {
//   if (!proposalData) return;
//   setLoading(true);
//   try {
//     const { pdf } = await import("@react-pdf/renderer");
//     const doc = proposalData.template === "2"
//       ? <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
//       : <MyProposalDocument loaction={proposalData.location} proposalData={proposalData} rfpData={rfpData} />;
//     const blob = await pdf(doc).toBlob();
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${proposalData.proposaltitile || "proposal"}.pdf`;
//     a.click();
//     URL.revokeObjectURL(url);
//   } catch {
//     Swal.fire({ icon: "error", text: "Failed to generate PDF." });
//   } finally {
//     setLoading(false);
//   }
// };

// const handlePrintPdf = async () => {
//   if (!proposalData) return;
//   setLoading(true);
//   try {
//     const { pdf } = await import("@react-pdf/renderer");
//     const doc = proposalData.template === "2"
//       ? <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
//       : <MyProposalDocument loaction={proposalData.location} proposalData={proposalData} rfpData={rfpData} />;
//     const blob = await pdf(doc).toBlob();
//     const url = URL.createObjectURL(blob);
//     const iframe = document.createElement("iframe");
//     iframe.style.display = "none";
//     iframe.src = url;
//     document.body.appendChild(iframe);
//     iframe.onload = () => {
//       iframe.contentWindow.print();
//       setTimeout(() => {
//         document.body.removeChild(iframe);
//         URL.revokeObjectURL(url);
//       }, 1000);
//     };
//   } catch {
//     Swal.fire({ icon: "error", text: "Failed to print PDF." });
//   } finally {
//     setLoading(false);
//   }
// };
  
//   const termsData = (() => {
//     try {
//       const raw = proposalData?.terms;
//       return typeof raw === "string" ? JSON.parse(raw) : raw || [];
//     } catch { return []; }
//   })();
//   const projectDuration = termsData[0]?.value || termsData[0]?.total || "-";
//   const projectCost = (() => {
//     const cost1 = parseFloat(termsData[1]?.value || termsData[1]?.total || 0) || 0;
//     const cost2 = parseFloat(termsData[2]?.value || termsData[2]?.total || 0) || 0;
//     const sym = termsData[1]?.currency || proposalData?.currency_symbol || "";
//     return cost1 + cost2 > 0
//       ? `${sym}${(cost1 + cost2).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`
//       : "As per agreement";
//   })();
//   const hostingCost = (() => {
//     const val = termsData[2]?.value || termsData[2]?.total;
//     if (!val) return null;
//     const sym = termsData[2]?.currency || proposalData?.currency_symbol || "";
//     return `${sym}${Number(val).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`;
//   })();

//   // Parse response data for display
// const responseData = proposalData?.proposal_response || null;
//   // ── Memoize PDF document to prevent re-render on every keystroke ──
// const pdfDocument = useMemo(() => {
//   if (!proposalData) return null;
//   return proposalData.template === "2"
//     ? <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
//     : <MyProposalDocument loaction={proposalData.location} proposalData={proposalData} rfpData={rfpData} />;
// }, [proposalData, rfpData]);


//   // ── Expired / not found ──
//   if (expire === true) {
//     return (
//       <section className="my-5 pt-sm-5">
//         <div className="container text-center">
//           <img src={zithasLogo} height="80" className="mb-4" />
//           <h2>Proposal Not Found</h2>
//           <p className="text-muted">This proposal link is invalid or has expired.</p>
//         </div>
//       </section>
//     );
//   }

//   if (expire === null) return <Loader />;



//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
//         <Container fluid>
//           <Row>
//             {/* ── LEFT: PDF Viewer ── */}
//             <div className="col-md-9 col-12 ps-md-0 order-md-1 order-2">
//               <div className="bg-white shadow" style={{ height: "860px" }}>
//                 {proposalData && (
//                   <PDFViewer width="100%" height="860px" style={{ border: "none" }}>
//                     {/* {proposalData.template === "2"
//                       ? <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
//                       : <MyProposalDocument loaction={proposalData.location} proposalData={proposalData} rfpData={rfpData} />
//                     } */}
//                     {pdfDocument}
//                   </PDFViewer>
//                 )}
//               </div>
//             </div>

//             {/* ── RIGHT: Info panel ── */}
//             <div className="col-md-3 col-12 pe-md-0 order-md-2 order-1 mb-md-0 mb-3">
//               {/* <div className={fixedRightSec ? "fixed-right-section top-0" : ""}> */}
//               <div
//   className={fixedRightSec ? "fixed-right-section top-0" : ""}
//   style={{
//     maxHeight: "100vh",
//     overflowY: "auto",
//     paddingBottom: "20px",
//   }}
// >

//                 {/* Action buttons */}
//                 <div className="col-12 text-md-end text-center mb-3">
//                   <button
//                     onClick={handlePrintPdf}
//                     className="btn btn-sm btn-success border-radius me-1"
//                   >
//                     <i className="fas fa-print me-1"></i> Print
//                   </button>
//                   <button
//                     onClick={handleDownloadPdf}
//                     className="btn btn-sm btn-secondary border-radius"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     <i className="fas fa-file-download me-1"></i> Download PDF
//                   </button>
//                 </div>

//                 {/* Proposal details card */}
//                 {/* <div className="bg-white p-3 mt-2 shadow">
//                   <h5 className="mb-4 text-dark fw-bold">
//                     {proposalData?.proposaltitile || "Proposal"}
//                   </h5>
//                   <h6 className="mb-3">
//                     <i className="fas fa-building me-2 text-purple"></i>
//                     {proposalData?.companyname || "-"}
//                   </h6>
//                   <hr />
//                   <h6 className="mb-2 text-muted" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
//                     Project Details
//                   </h6>
//                   <div className="mb-2">
//                     <small className="text-muted">Project Costing</small>
//                     <div className="fw-bold">{projectCost}</div>
//                   </div>
//                   <div className="mb-2">
//                     <small className="text-muted">Project Duration</small>
//                     <div className="fw-bold">{projectDuration}</div>
//                   </div>
//                   {hostingCost && (
//                     <div className="mb-2">
//                       <small className="text-muted">Hosting / Domain / SSL</small>
//                       <div className="fw-bold">{hostingCost}</div>
//                     </div>
//                   )}
//                 </div> */}
//                 {/* Proposal details card */}
// <div className="bg-white mt-2 shadow" style={{ overflow: "hidden"}}>
//   {/* Header strip */}
//   <div style={{padding: "16px 20px", borderBottom: "1px solid #f0f0f0" }}>
//     <h6 className="mb-1 fw-bold" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.8 }}>
//       Proposal
//     </h6>
//     <h5 className="mb-0 fw-bold" style={{ fontSize: "12px", lineHeight: "1.3" }}>
//       {proposalData?.proposaltitile || "Proposal"}
//     </h5>
//   </div>

//   {/* Company row */}
//   <div style={{ padding: "7px 20px", borderBottom: "1px solid #f0f0f0", display: "flex", alignItems: "center", gap: "10px" }}>
//     {/* <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: "#f0e8f4", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
//       <i className="fas fa-building text-purple" style={{ fontSize: "13px" }}></i>
//     </div> */}
//     <div>
//       <div style={{ fontSize: "10px", color: "#aaa", textTransform: "uppercase", letterSpacing: "0.5px" }}>Client</div>
//       <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>{proposalData?.companyname || "-"}</div>
//     </div>
//   </div>

//   {/* Details rows */}
//   <div style={{ padding: "6px 0" }}>
//     {/* Project Cost */}
//     <div style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f8f8f8" }}>
//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         <i className="fas fa-rupee-sign text-muted" style={{ fontSize: "12px", width: "14px" }}></i>
//         <span className="text-muted" style={{ fontSize: "12px" }}>Project Cost</span>
//       </div>
//       <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>{projectCost}</span>
//     </div>

//     {/* Project Duration */}
//     <div style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f8f8f8" }}>
//       <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//         <i className="fas fa-clock text-muted" style={{ fontSize: "12px", width: "14px" }}></i>
//         <span className="text-muted" style={{ fontSize: "12px" }}>Duration</span>
//       </div>
//       <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>{projectDuration}</span>
//     </div>

//     {/* Hosting — conditional */}
//     {hostingCost && (
//       <div style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #f8f8f8" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//           <i className="fas fa-server text-muted" style={{ fontSize: "12px", width: "14px" }}></i>
//           <span className="text-muted" style={{ fontSize: "12px" }}>Hosting / SSL</span>
//         </div>
//         <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>{hostingCost}</span>
//       </div>
//     )}

//     {/* Valid till */}
//     {proposalData?.opentill && (
//       <div style={{ padding: "10px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//           <i className="fas fa-calendar-alt text-muted" style={{ fontSize: "12px", width: "14px" }}></i>
//           <span className="text-muted" style={{ fontSize: "12px" }}>Valid Till</span>
//         </div>
//         <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>
//           {new Date(proposalData.opentill).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
//         </span>
//       </div>
//     )}
//   </div>
// </div>

//                 {/* Accept / Reject */}
// <div className="bg-white p-3 mt-3 shadow">
//   {responded || responseData ? (
//     <div className={`alert ${responseData?.action === "rejected" ? "alert-danger" : "alert-success"} mb-0`}>
//       <strong>
//         {responseData?.action === "rejected" ? "Proposal Declined" : "Proposal Accepted"}
//       </strong>
//       {responseData?.reason && (
//         <p className="mb-1 mt-2" style={{ fontSize: "13px" }}>
//           <span className="text-muted">Reason: </span>{responseData.reason}
//         </p>
//       )}
//       {responseData?.responded_at && (
//         <p className="mb-0 mt-1 text-muted" style={{ fontSize: "11px" }}>
//           {new Date(responseData.responded_at).toLocaleString()}
//         </p>
//       )}
//       {!responseData?.responded_at && (
//         <p className="mb-0 mt-1" style={{ fontSize: "13px" }}>
//           Thank you for your response.
//         </p>
//       )}
//     </div>
//   ) : (
//     <>
//       <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
//         Please review the proposal and let us know your decision.
//       </p>
//       <button
//         className="btn btn-success w-100 mb-2"
//         onClick={handleAccept}
//       >
//         <i className="fas fa-check me-2"></i> Accept Proposal
//       </button>
//       <button
//         className="btn btn-outline-danger w-100"
//         onClick={() => setRejectModal(true)}
//       >
//         <i className="fas fa-times me-2"></i> Decline Proposal
//       </button>
//     </>
//   )}
// </div>

//               </div>
//             </div>
//           </Row>
//         </Container>
//       </div>

//       {/* Reject Modal */}
//       <Modal isOpen={rejectModal} centered size="md" toggle={() => setRejectModal(false)}>
//         <div className="modal-header">
//           <h5 className="modal-title mt-0">Reason for Declining</h5>
//           <button
//             type="button"
//             onClick={() => setRejectModal(false)}
//             className="btn-modal-close"
//           >
//             <span className="btn-modal-span">&times;</span>
//           </button>
//         </div>
//         <div className="modal-body">
//   <div className="mb-3">
//     <label>Please tell us why you're declining this proposal</label>
//     <textarea
//       className="form-control mt-2"
//       rows="4"
//       placeholder="Enter your reason..."
//       value={rejectReason}
//       onChange={(e) => setRejectReason(e.target.value)}
//     />
//   </div>
//   <div className="text-end">
//     <button
//       type="button"
//       className="btn btn-secondary me-2"
//       onClick={() => setRejectModal(false)}
//     >
//       Cancel
//     </button>
//     <button
//       type="button"
//       className="btn btn-danger btn-label"
//       onClick={handleReject}
//     >
//       <i className="fas fa-times me-2 label-icon"></i>
//       Submit & Decline
//     </button>
//   </div>
// </div>
//       </Modal>
//     </React.Fragment>
//   );
// };

// export default GenerateLinkProposal;


import React, { useEffect, useRef, useState, useMemo } from "react";
import { Container, Row, Modal, Form } from "reactstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import Swal from "sweetalert2";
import zithasLogo from "../../../assets/images/zithas-dark-logo.png";
import { MyProposalDocument } from "./ProposalPdf";
import { ProposalPDFDoc } from "./ProposalPdfBlank";

const GenerateLinkProposal = () => {
  const params = useParams();
  // junk_link can contain "#", which the browser treats as the URL fragment,
  // so links shared before encoding was added arrive split across id + hash
  const junk_link = `${params.id || ""}${window.location.hash || ""}`;
  const [isLoading, setLoading] = useState(false);
  const [expire, setExpire] = useState(null); // null = loading
  const [proposalData, setProposalData] = useState(null);
  const [rfpData, setRfpData] = useState(null);
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [responded, setResponded] = useState(false);
  const [fixedRightSec, setFixedRightSec] = useState(false);

  // ── Holds the generated PDF blob URL for inline display ──
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfRendering, setPdfRendering] = useState(false);

  useEffect(() => {
    const handleScroll = () => setFixedRightSec(window.scrollY > 48);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    fetchProposal();
  }, []);

  const fetchProposal = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${configure.nodeApi}/get_proposal_by_junk_link/${encodeURIComponent(junk_link)}`,
        { headers: { Accept: "application/json" } }
      );
      if (res.data.success && res.data.data) {
        const d = res.data.data;
        setProposalData(d);
        setExpire(false);

        // Check if already responded
        if (d.proposal_response?.action) setResponded(true);

        // Fetch RFP if linked to lead
        if (d.related === "lead" && d.source_name && d.source_name !== "null") {
          try {
            const rfpRes = await axios.get(
              `${configure.nodeApi}/get_rfp_by_lead/${d.source_name}`,
              { headers: { Accept: "application/json" } }
            );
            if (rfpRes.data.success && rfpRes.data.data) setRfpData(rfpRes.data.data);
          } catch {}
        }
      } else {
        setExpire(true);
      }
    } catch {
      setExpire(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = async () => {
    const { isConfirmed } = await Swal.fire({
      title: "Accept Proposal?",
      text: "By accepting, you agree to proceed with this proposal.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Accept",
      confirmButtonColor: "#28a745",
    });
    if (!isConfirmed) return;

    setLoading(true);
    try {
      await axios.post(`${configure.nodeApi}/proposal_response`, {
        junk_link,
        action: "accepted",
        reason: null,
      });
      setResponded(true);
      Swal.fire({ icon: "success", text: "Proposal Accepted! We'll be in touch soon." });
    } catch {
      Swal.fire({ icon: "error", text: "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async () => {
    if (!rejectReason.trim()) return;
    setLoading(true);
    try {
      await axios.post(`${configure.nodeApi}/proposal_response`, {
        junk_link,
        action: "rejected",
        reason: rejectReason,
      });
      setResponded(true);
      setRejectModal(false);
      Swal.fire({ icon: "info", text: "Proposal declined. Thank you for your feedback." });
    } catch {
      Swal.fire({ icon: "error", text: "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  // Add this helper after handleReject
  const handleDownloadPdf = async () => {
    if (!proposalData) return;
    setLoading(true);
    try {
      const { pdf } = await import("@react-pdf/renderer");
      const doc =
        proposalData.template === "2" ? (
          <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
        ) : (
          <MyProposalDocument
            loaction={proposalData.location}
            proposalData={proposalData}
            rfpData={rfpData}
          />
        );
      const blob = await pdf(doc).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${proposalData.proposaltitile || "proposal"}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      Swal.fire({ icon: "error", text: "Failed to generate PDF." });
    } finally {
      setLoading(false);
    }
  };

  const handlePrintPdf = async () => {
    if (!proposalData) return;
    setLoading(true);
    try {
      const { pdf } = await import("@react-pdf/renderer");
      const doc =
        proposalData.template === "2" ? (
          <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
        ) : (
          <MyProposalDocument
            loaction={proposalData.location}
            proposalData={proposalData}
            rfpData={rfpData}
          />
        );
      const blob = await pdf(doc).toBlob();
      const url = URL.createObjectURL(blob);
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = url;
      document.body.appendChild(iframe);
      iframe.onload = () => {
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(url);
        }, 1000);
      };
    } catch {
      Swal.fire({ icon: "error", text: "Failed to print PDF." });
    } finally {
      setLoading(false);
    }
  };

  // ── Parse terms for display ──
  const termsData = (() => {
    try {
      const raw = proposalData?.terms;
      return typeof raw === "string" ? JSON.parse(raw) : raw || [];
    } catch {
      return [];
    }
  })();
  const projectDuration = termsData[0]?.value || termsData[0]?.total || "-";
  const projectCost = (() => {
    const cost1 = parseFloat(termsData[1]?.value || termsData[1]?.total || 0) || 0;
    const cost2 = parseFloat(termsData[2]?.value || termsData[2]?.total || 0) || 0;
    const sym = termsData[1]?.currency || proposalData?.currency_symbol || "";
    return cost1 + cost2 > 0
      ? `${sym}${(cost1 + cost2).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`
      : "As per agreement";
  })();
  const hostingCost = (() => {
    const val = termsData[2]?.value || termsData[2]?.total;
    if (!val) return null;
    const sym = termsData[2]?.currency || proposalData?.currency_symbol || "";
    return `${sym}${Number(val).toLocaleString("en-GB", { minimumFractionDigits: 2 })}`;
  })();

  // Parse response data for display
  const responseData = proposalData?.proposal_response || null;

  // ── Memoize PDF document element (used to build the blob) ──
  const pdfDocument = useMemo(() => {
    if (!proposalData) return null;
    return proposalData.template === "2" ? (
      <ProposalPDFDoc proposalData={proposalData} rfpData={rfpData} />
    ) : (
      <MyProposalDocument
        loaction={proposalData.location}
        proposalData={proposalData}
        rfpData={rfpData}
      />
    );
  }, [proposalData, rfpData]);

  // ── Render the PDF to a blob URL so we can show it in a clean iframe ──
  // (PDFViewer renders the browser's dark PDF chrome / black background;
  //  using a blob URL with #toolbar=0 gives a clean inline document view)
  useEffect(() => {
    let cancelled = false;
    let createdUrl = null;

    const buildPdf = async () => {
      if (!pdfDocument) return;
      setPdfRendering(true);
      try {
        const { pdf } = await import("@react-pdf/renderer");
        const blob = await pdf(pdfDocument).toBlob();
        if (cancelled) return;
        createdUrl = URL.createObjectURL(blob);
        setPdfUrl(createdUrl);
      } catch (err) {
        console.error("PDF render error:", err);
      } finally {
        if (!cancelled) setPdfRendering(false);
      }
    };

    buildPdf();

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [pdfDocument]);

  // ── Expired / not found ──
  if (expire === true) {
    return (
      <section className="my-5 pt-sm-5">
        <div className="container text-center">
          <img src={zithasLogo} height="80" className="mb-4" />
          <h2>Proposal Not Found</h2>
          <p className="text-muted">This proposal link is invalid or has expired.</p>
        </div>
      </section>
    );
  }

  if (expire === null) return <Loader />;

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-2" style={{ paddingTop: "60px" }}>
        <Container fluid>
          <Row>
            {/* ── LEFT: Inline PDF (clean, no PDFViewer black background) ── */}
            <div className="col-md-9 col-12 ps-md-0 order-md-1 order-2">
              <div className="bg-white shadow" style={{ height: "860px", backgroundColor: "#ffffff" }}>
                {pdfUrl ? (
                  <iframe
                    title="Proposal"
                    src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                    width="100%"
                    height="860px"
                    style={{ border: "none", display: "block", backgroundColor: "#ffffff" }}
                  />
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ height: "860px" }}
                  >
                    {pdfRendering ? (
                      <span className="text-muted">Loading proposal…</span>
                    ) : null}
                  </div>
                )}
              </div>
            </div>

            {/* ── RIGHT: Info panel ── */}
            <div className="col-md-3 col-12 pe-md-0 order-md-2 order-1 mb-md-0 mb-3">
              <div
                className={fixedRightSec ? "fixed-right-section top-0" : ""}
                style={{
                  maxHeight: "100vh",
                  overflowY: "auto",
                  paddingBottom: "20px",
                }}
              >
                {/* Action buttons */}
                <div className="col-12 text-md-end text-center mb-3">
                  <button
                    onClick={handlePrintPdf}
                    className="btn btn-sm btn-success border-radius me-1"
                  >
                    <i className="fas fa-print me-1"></i> Print
                  </button>
                  <button
                    onClick={handleDownloadPdf}
                    className="btn btn-sm btn-secondary border-radius"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fas fa-file-download me-1"></i> Download PDF
                  </button>
                </div>

                {/* Proposal details card */}
                <div className="bg-white mt-2 shadow" style={{ overflow: "hidden" }}>
                  {/* Header strip */}
                  <div style={{ padding: "16px 20px", borderBottom: "1px solid #f0f0f0" }}>
                    <h6
                      className="mb-1 fw-bold"
                      style={{
                        fontSize: "11px",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        opacity: 0.8,
                      }}
                    >
                      Proposal
                    </h6>
                    <h5 className="mb-0 fw-bold" style={{ fontSize: "12px", lineHeight: "1.3" }}>
                      {proposalData?.proposaltitile || "Proposal"}
                    </h5>
                  </div>

                  {/* Company row */}
                  <div
                    style={{
                      padding: "7px 20px",
                      borderBottom: "1px solid #f0f0f0",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: "10px",
                          color: "#aaa",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Client
                      </div>
                      <div className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                        {proposalData?.companyname || "-"}
                      </div>
                    </div>
                  </div>

                  {/* Details rows */}
                  <div style={{ padding: "6px 0" }}>
                    {/* Project Cost */}
                    <div
                      style={{
                        padding: "10px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #f8f8f8",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <i
                          className="fas fa-rupee-sign text-muted"
                          style={{ fontSize: "12px", width: "14px" }}
                        ></i>
                        <span className="text-muted" style={{ fontSize: "12px" }}>
                          Project Cost
                        </span>
                      </div>
                      <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                        {projectCost}
                      </span>
                    </div>

                    {/* Project Duration */}
                    <div
                      style={{
                        padding: "10px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #f8f8f8",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <i
                          className="fas fa-clock text-muted"
                          style={{ fontSize: "12px", width: "14px" }}
                        ></i>
                        <span className="text-muted" style={{ fontSize: "12px" }}>
                          Duration
                        </span>
                      </div>
                      <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                        {projectDuration}
                      </span>
                    </div>

                    {/* Hosting — conditional */}
                    {hostingCost && (
                      <div
                        style={{
                          padding: "10px 20px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          borderBottom: "1px solid #f8f8f8",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <i
                            className="fas fa-server text-muted"
                            style={{ fontSize: "12px", width: "14px" }}
                          ></i>
                          <span className="text-muted" style={{ fontSize: "12px" }}>
                            Hosting / SSL
                          </span>
                        </div>
                        <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                          {hostingCost}
                        </span>
                      </div>
                    )}

                    {/* Valid till */}
                    {proposalData?.opentill && (
                      <div
                        style={{
                          padding: "10px 20px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <i
                            className="fas fa-calendar-alt text-muted"
                            style={{ fontSize: "12px", width: "14px" }}
                          ></i>
                          <span className="text-muted" style={{ fontSize: "12px" }}>
                            Valid Till
                          </span>
                        </div>
                        <span className="fw-bold text-dark" style={{ fontSize: "13px" }}>
                          {new Date(proposalData.opentill).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Accept / Reject */}
                <div className="bg-white p-3 mt-3 shadow">
                  {responded || responseData ? (
                    <div
                      className={`alert ${
                        responseData?.action === "rejected" ? "alert-danger" : "alert-success"
                      } mb-0`}
                    >
                      <strong>
                        {responseData?.action === "rejected"
                          ? "Proposal Declined"
                          : "Proposal Accepted"}
                      </strong>
                      {responseData?.reason && (
                        <p className="mb-1 mt-2" style={{ fontSize: "13px" }}>
                          <span className="text-muted">Reason: </span>
                          {responseData.reason}
                        </p>
                      )}
                      {responseData?.responded_at && (
                        <p className="mb-0 mt-1 text-muted" style={{ fontSize: "11px" }}>
                          {new Date(responseData.responded_at).toLocaleString()}
                        </p>
                      )}
                      {!responseData?.responded_at && (
                        <p className="mb-0 mt-1" style={{ fontSize: "13px" }}>
                          Thank you for your response.
                        </p>
                      )}
                    </div>
                  ) : (
                    <>
                      <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
                        Please review the proposal and let us know your decision.
                      </p>
                      <button className="btn btn-success w-100 mb-2" onClick={handleAccept}>
                        <i className="fas fa-check me-2"></i> Accept Proposal
                      </button>
                      {/* <button
                        className="btn btn-outline-danger w-100"
                        onClick={() => setRejectModal(true)}
                      >
                        <i className="fas fa-times me-2"></i> Decline Proposal
                      </button> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </div>

      {/* Reject Modal */}
      <Modal isOpen={rejectModal} centered size="md" toggle={() => setRejectModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Reason for Declining</h5>
          <button
            type="button"
            onClick={() => setRejectModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="mb-3">
            <label>Please tell us why you're declining this proposal</label>
            <textarea
              className="form-control mt-2"
              rows="4"
              placeholder="Enter your reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
            />
          </div>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => setRejectModal(false)}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-danger btn-label" onClick={handleReject}>
              <i className="fas fa-times me-2 label-icon"></i>
              Submit & Decline
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default GenerateLinkProposal;